import { useEffect, useState } from "react";
import "./global.css"
import BackButton from "../../../Components/BackButton";
import RankingTable from "../../../Components/RankinkTable";
import TitlePages from "../../../Components/TitlePages";
import { useRankingIndustry } from "../../../providers/RankingIndustryContext";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {
  Container,
  SizeContainer,
  Header,
  MainContainer,
  Container1
} from "./style";
import Loading from "../../../Components/Loading";
import { useGame } from "../../../providers/GameContext";
import CountUp from "react-countup";

const RankingIndustry = () => {
  const [key, setKey] = useState('actual');
  const { activeGame, allGames } = useGame()
  const { rankingInActualGamesFilteredByRound,
    setupRankings,
    loading,
    industriesInActualGame,
    fetchRoundsInGame,
    fetchIndustriesInActualGame,
    rounds,
    globalRankingndustries
  } = useRankingIndustry()

  useEffect(() => {
    console.log(industriesInActualGame);
    if (industriesInActualGame?.length === 0) return
    setupRankings()
  }, [industriesInActualGame, rounds])

  useEffect(() => {
    if (!activeGame?.jogo) return
    fetchIndustriesInActualGame()
    fetchRoundsInGame()
  }, [activeGame])

  return (
    <Container>

      <SizeContainer>
        <TitlePages text="Ranking Indústria" />
        <Header>
          <BackButton path="/menuIndustry" />
        </Header>
        <MainContainer>

          <Tabs
            style={{
              width: '100%',
              justifyContent: 'center',
              paddingTop: 10,
            }}
            id="controlled-tab-example"
            fill
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3"
          >
            <Tab eventKey="actual" title="Jogo Atual">
              {loading ? (
                <Loading />
              ) : rankingInActualGamesFilteredByRound?.length === 0 ? <span style={{
                borderRadius: '15px',
                textAlign: 'center',
                fontSize: '18px',
                display: 'flex',
                alignSelf: 'center',
                justifyContent: 'center',

                alignItems: 'center',
                fontWeight: 'bold',
                width: '100%',
                padding: "15px",
                backgroundColor: '#fa821f'
              }}>Nenhuma indústria jogou.</span> : rankingInActualGamesFilteredByRound?.map((item, index) => (
                <RankingTable index={(index + 1)} key={index} content={item} />
              ))
              }
            </Tab>
            <Tab style={{ width: '100%' }} eventKey="acumulated" title="Acumulado">
              {loading ? (
                <Loading />
              ) : globalRankingndustries?.length === 0 ? <span style={{
                borderRadius: '15px',
                textAlign: 'center',
                fontSize: '18px',
                fontWeight: 'bold',
                width: '100%',
                padding: "15px",
                backgroundColor: '#fa821f'
              }}>Nenhuma indústria jogou.</span> : globalRankingndustries?.map((item, index) => (
                <Container1>
                  <tr key={index}>
                    <td className='nameRow'>{item.nome}</td>
                    <td>
                      <CountUp
                        style={{ color: item.margemBruta < 0 ? 'red' : '#2AFAA5' }}
                        end={item.margemBruta}
                        prefix=" R$ "
                        separator="."
                        decimal=","
                        decimals={2}
                        duration={0.5}
                      />
                    </td>
                  </tr>
                </Container1>
              ))
              }
            </Tab>
          </Tabs>


          {/* <AccumulatedHeader>
            <h3>Acumulado</h3>
          </AccumulatedHeader>
          {accumulated.map((item, index) => (
            <RankingTable key={index} content={item} />
          ))} */}
        </MainContainer>
      </SizeContainer>
    </Container>
  );
};
export default RankingIndustry;
